import {i18n} from '../../translate/i18n'

const hospitalityBreadCrumbs: Array<{name: string; path: string}> = [
  {name: i18n.t(`permissions.locations`), path: '/hospitality/configuracoes/setores'},
  {
    name: `${i18n.t(`buttons.create`)} ${i18n.t(`permissions.locations`)}`,
    path: '/hospitality/configuracoes/setores/criar',
  },
  {
    name: `${i18n.t(`general.edit`)} ${i18n.t(`permissions.locations`)}`,
    path: '/hospitality/configuracoes/setores/editar/:id',
  },

  {name: 'Ícones', path: '/hospitality/configuracoes/icones'},

  {name: i18n.t('stores_pages.title'), path: '/hospitality/configuracoes/stores'},
  {name: i18n.t('stores_pages_create.title'), path: '/hospitality/configuracoes/stores/create'},
  {name: i18n.t('stores_pages_edit.title'), path: '/hospitality/configuracoes/stores/edit/:id'},

  {name: i18n.t(`permissions.service`), path: '/hospitality/service-item'},
  {
    name: `${i18n.t(`buttons.create`)} ${i18n.t(`permissions.service`)}`,
    path: '/hospitality/service-item/create',
  },
  {
    name: `${i18n.t(`general.edit`)} ${i18n.t(`permissions.service`)}`,
    path: '/hospitality/service-item/update/:id',
  },

  {name: i18n.t(`permissions.serviceCategory`), path: '/hospitality/service-category'},
  {
    name: `${i18n.t(`buttons.create`)} ${i18n.t(`permissions.serviceCategory`)}`,
    path: '/hospitality/service-category/create',
  },
  {
    name: `${i18n.t(`general.edit`)} ${i18n.t(`permissions.serviceCategory`)}`,
    path: '/hospitality/service-category/update/:id',
  },
  {name: i18n.t(`hospitality_content.category.page_title`), path: '/hospitality/content/category'},
  {
    name: `${i18n.t(`buttons.create`)} ${i18n.t(`hospitality_content.category.page_title`)}`,
    path: '/hospitality/content/category/criar',
  },
  {
    name: `${i18n.t(`general.edit`)} ${i18n.t(`hospitality_content.category.page_title`)}`,
    path: '/hospitality/content/category/editar/:id',
  },

  {name: i18n.t(`hospitality_content.page_title`), path: '/hospitality/content/content'},
  {
    name: `${i18n.t(`buttons.create`)} ${i18n.t(`feed.content`)}`,
    path: '/hospitality/content/content/create',
  },
  {
    name: `${i18n.t(`general.edit`)} ${i18n.t(`feed.content`)}`,
    path: '/hospitality/content/content/editar/:id',
  },

  {name: i18n.t(`permissions.sds_display`), path: '/sds/manage-hospitality'},
  {
    name: `${i18n.t(`buttons.create`)} ${i18n.t(`permissions.sds_display`)}`,
    path: '/sds/manage-hospitality/create',
  },

  /*Hotel Room */
  {name: `${i18n.t(`permissions.hotel_room`)}`, path: '/hospitality/hotel-room'},
  {
    name: `${i18n.t(`buttons.create`)} ${i18n.t(`permissions.hotel_room`)}`,
    path: '/hospitality/hotel-room/criar',
  },
  {
    name: ` ${i18n.t(`hospitality_hotel_room.edit_title`)}`,
    path: '/hospitality/hotel-room/editar/:id',
  },
  /*Hotel Room Reservation */
  {name: `${i18n.t(`permissions.hotel_reservation`)}`, path: '/hospitality/hotel-reservation'},
  {
    name: `${i18n.t(`buttons.create`)} ${i18n.t(`permissions.hotel_reservation`)}`,
    path: '/hospitality/hotel-reservation/criar',
  },
  {
    name: `${i18n.t(`general.edit`)} ${i18n.t(`permissions.hotel_reservation`)}`,
    path: '/hospitality/hotel-reservation/editar/:id',
  },

  /*Hotel Room Activities */
  {name: `${i18n.t(`permissions.hotel_activities`)}`, path: '/hospitality/hotel-activities'},
  {
    name: `${i18n.t(`buttons.create`)} ${i18n.t(`permissions.hotel_activities`)}`,
    path: '/hospitality/hotel-activities/criar',
  },
  {
    name: `${i18n.t(`general.edit`)} ${i18n.t(`permissions.hotel_activities`)}`,
    path: '/hospitality/hotel-activities/editar/:id',
  },

  /*Structured Content*/
  {name: 'Clean & Safe', path: '/hospitality/structured-content/clean-safe'},
  {
    name: i18n.t('service_requests.title'),
    path: '/hospitality/structured-content/service-requests',
  },
  {
    name: i18n.t('service_requests.create'),
    path: '/hospitality/structured-content/service-requests/create',
  },
  {
    name: i18n.t('service_requests.edit'),
    path: '/hospitality/structured-content/service-requests/edit/:id',
  },
  {
    name: i18n.t('service_grid.service_grid_single'),
    path: '/hospitality/structured-content/grid-hotel',
  },
  {
    name: i18n.t('service_grid.create_service_grid'),
    path: '/hospitality/structured-content/grid-hotel/create',
  },
  {
    name: i18n.t('service_grid.edit_service_grid'),
    path: '/hospitality/structured-content/grid-hotel/edit/:id',
  },

  /*Turismo do Hotel */
  {name: `${i18n.t(`permissions.hotel_tour`)}`, path: '/hospitality/tours'},
  {
    name: `${i18n.t(`buttons.create`)} ${i18n.t(`permissions.hotel_tour`)}`,
    path: '/hospitality/tours/criar',
  },
  {
    name: `${i18n.t(`general.edit`)} ${i18n.t(`permissions.hotel_tour`)}`,
    path: '/hospitality/tours/editar/:id',
  },

  {name: `${i18n.t(`permissions.hotel_experiences`)}`, path: '/hospitality/hotel-experiences'},
  {
    name: `${i18n.t(`buttons.create`)} ${i18n.t(`permissions.hotel_experiences`)}`,
    path: '/hospitality/hotel-experiences/criar',
  },
  {
    name: `${i18n.t(`general.edit`)} ${i18n.t(`permissions.hotel_experiences`)}`,
    path: '/hospitality/hotel-experiences/editar/:id',
  },

  {name: `${i18n.t(`permissions.hotel_info`)}`, path: '/hospitality/hotel-info'},

  {name: `${i18n.t(`permissions.hotel_reservations`)}`, path: '/hospitality/tours-reservations'},

  {name: `${i18n.t(`permissions.hotel_schedules`)}`, path: '/hospitality/hotel-schedules'},
  {
    name: `${i18n.t(`buttons.create`)} ${i18n.t(`permissions.hotel_schedules`)}`,
    path: '/hospitality/hotel-schedules/criar',
  },
  {
    name: `${i18n.t(`general.edit`)} ${i18n.t(`permissions.hotel_schedules`)}`,
    path: '/hospitality/hotel-schedules/editar/:id',
  },

  /* Orders */
  {name: i18n.t('permissions.orders_room_service'), path: '/hospitality/orders/room-service'},
  {name: i18n.t('permissions.orders_activities'), path: '/hospitality/orders/activities'},
  {
    name: i18n.t('permissions.orders_service_reservation'),
    path: '/hospitality/orders/service-reservation',
  },

  {name: `Banner de Destaque`, path: '/hospitality/publicity'},
  {name: `Criar Banner de Destaque`, path: '/hospitality/publicity/create'},
  {name: `Editar Banner de Destaque`, path: '/hospitality/publicity/editar/:id'},

  {name: `Publicidade`, path: '/hospitality/publicity-banner'},
  {name: `Criar Publicidade`, path: '/hospitality/publicity-banner/create'},
  {name: `Editar Publicidade`, path: '/hospitality/publicity-banner/editar/:id'},

  {name: `Feed Back`, path: '/hospitality/feed-back'},

  {
    name: i18n.t('gridHotelFeedback.service_grid'),
    path: '/hospitality/feedback-satisfaction/grid-hotel-feedback',
  },
  {
    name: i18n.t('gridHotelFeedback.create_service_grid'),
    path: '/hospitality/feedback-satisfaction/grid-hotel-feedback/create',
  },
  {
    name: i18n.t('gridHotelFeedback.edit_service_grid'),
    path: '/hospitality/feedback-satisfaction/grid-hotel-feedback/edit/:id',
  },

  {
    name: i18n.t('satisfaction_feedback.title'),
    path: '/hospitality/feedback-satisfaction/feedback-list',
  },
  {
    name: i18n.t('satisfaction_feedback.create'),
    path: '/hospitality/feedback-satisfaction/feedback-list/create',
  },
  {
    name: i18n.t('satisfaction_feedback.edit'),
    path: '/hospitality/feedback-satisfaction/feedback-list/edit/:id',
  },
  {
    name: i18n.t('permissions.feedback'),
    path: '/hospitality/feedback-satisfaction/feedback',
  },

  {name: `${i18n.t(`permissions.page_publications`)}`, path: '/hospitality/content/section'},
  {
    name: `${i18n.t(`buttons.create`)} ${i18n.t(`permissions.page_publications`)}`,
    path: '/hospitality/content/section/criar',
  },
  {
    name: `${i18n.t(`general.edit`)} ${i18n.t(`permissions.page_publications`)}`,
    path: '/hospitality/content/section/editar/:id',
  },

  {name: `${i18n.t(`permissions.post`)}`, path: '/hospitality/posts'},
  {
    name: `${i18n.t(`buttons.create`)} ${i18n.t(`permissions.post`)}`,
    path: '/hospitality/posts/criar',
  },
  {
    name: `${i18n.t(`general.edit`)} ${i18n.t(`permissions.post`)}`,
    path: '/hospitality/posts/editar/:id',
  },

  {name: `${i18n.t(`permissions.post_category`)}`, path: '/hospitality/posts/category'},
  {
    name: `${i18n.t(`buttons.create`)} ${i18n.t(`permissions.post_category`)}`,
    path: '/hospitality/posts/category/criar',
  },
  {
    name: `${i18n.t(`general.edit`)} ${i18n.t(`permissions.post_category`)}`,
    path: '/hospitality/posts/category/editar/:id',
  },

  {name: `${i18n.t(`permissions.page_publications`)}`, path: '/hospitality/content/section'},
  {
    name: `${i18n.t(`buttons.create`)} ${i18n.t(`permissions.page_publications`)}`,
    path: '/hospitality/content/section/criar',
  },
  {
    name: `${i18n.t(`general.edit`)} ${i18n.t(`permissions.page_publications`)}`,
    path: '/hospitality/content/section/editar/:id',
  },

  {name: `${i18n.t(`permissions.post`)}`, path: '/hospitality/posts'},
  {
    name: `${i18n.t(`buttons.create`)} ${i18n.t(`permissions.post`)}`,
    path: '/hospitality/posts/criar',
  },
  {
    name: `${i18n.t(`general.edit`)} ${i18n.t(`permissions.post`)}`,
    path: '/hospitality/posts/editar/:id',
  },

  {name: `${i18n.t(`permissions.post_category`)}`, path: '/hospitality/posts/category'},
  {
    name: `${i18n.t(`buttons.create`)} ${i18n.t(`permissions.post_category`)}`,
    path: '/hospitality/posts/category/criar',
  },
  {
    name: `${i18n.t(`general.edit`)} ${i18n.t(`permissions.post_category`)}`,
    path: '/hospitality/posts/category/editar/:id',
  },
  {
    name: i18n.t('gridHotelFeedback.service_grid'),
    path: '/hospitality/context/grid-hotel-booking',
  },
  {
    name: `${i18n.t('buttons.create')} ${i18n.t('gridHotelFeedback.service_grid')}`,
    path: '/hospitality/context/grid-hotel-booking/create',
  },
  {
    name: `${i18n.t('general.edit')} ${i18n.t('gridHotelFeedback.service_grid')}`,
    path: '/hospitality/context/grid-hotel-booking/edit/:id',
  },
  {
    name: i18n.t('booking_hotel_services.page_title'),
    path: '/hospitality/context/booking_config_hotel',
  },
  {
    name: `${i18n.t('buttons.create')} ${i18n.t('booking_hotel_services.page_title')}`,
    path: '/hospitality/context/booking_config_hotel/create',
  },
  {
    name: `${i18n.t('general.edit')} ${i18n.t('booking_hotel_services.page_title')}`,
    path: '/hospitality/context/booking_config_hotel/edit/:id',
  },
]

export {hospitalityBreadCrumbs}
